import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TenantAccessState {
	expiredTrial: boolean;
	inactive: boolean;
}

const initialState: TenantAccessState = {
	expiredTrial: false,
	inactive: false
};

export const tenantAccessSlice = createSlice({
	initialState,
	name: "tenantAccess",
	reducers: {
		clearTenantInactive: (state) => {
			state.inactive = false;
			state.expiredTrial = false;
		},
		tenantInactiveDetected: (state, action: PayloadAction<{ expiredTrial: boolean }>) => {
			state.inactive = true;
			state.expiredTrial = action.payload.expiredTrial;
		}
	}
});

export const { clearTenantInactive, tenantInactiveDetected } = tenantAccessSlice.actions;

export default tenantAccessSlice.reducer;
